var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',[_c('img',{attrs:{"src":_vm.img,"size":64}})])}
var staticRenderFns = []

export { render, staticRenderFns }